/**
 * Page-specific FAQ copy (IT/EN). Each page renders its own set visibly in
 * the DOM and feeds the same Q&A pairs into that page's FAQPage JSON-LD via
 * usePageSchema — the two must stay in sync, unlike the old single FAQPage
 * block that was injected identically on every page but visible on none.
 */
export const FAQ_HOME = {
  it: [
    {
      q: 'Cos’è il ciclo economico e in che fase ci troviamo?',
      a: 'Il ciclo economico è l’alternanza naturale tra fasi di espansione e contrazione dell’economia. Questa dashboard calcola la fase attuale in tempo reale combinando S&P 500, VIX, Fear & Greed Index, medie mobili e ampiezza settoriale, secondo un modello sinusoidale ispirato a Ray Dalio e Howard Marks.',
    },
    {
      q: 'Da dove arrivano i dati mostrati in dashboard?',
      a: 'Indici e settori da Yahoo Finance, tasso Fed da FRED (St. Louis Fed), Bitcoin e Total3 da CoinGecko, sentiment da CNN Fear & Greed Index e VIX da CBOE. Il punteggio del ciclo e la diagnosi sono calcolati da un modello sviluppato da me a partire da questi dati, e non costituiscono consulenza finanziaria.',
    },
  ],
  en: [
    {
      q: 'What is the economic cycle and what phase are we in?',
      a: 'The economic cycle is the natural alternation between expansion and contraction phases of the economy. This dashboard computes the current phase in real time by combining the S&P 500, VIX, Fear & Greed Index, moving averages and sector breadth, using a sinusoidal model inspired by Ray Dalio and Howard Marks.',
    },
    {
      q: 'Where does the data shown on the dashboard come from?',
      a: 'Indices and sectors from Yahoo Finance, the Fed rate from FRED (St. Louis Fed), Bitcoin and Total3 from CoinGecko, sentiment from the CNN Fear & Greed Index and VIX from CBOE. The cycle score and diagnosis come from a model I built on top of that data, and do not constitute financial advice.',
    },
  ],
};

export const FAQ_ABOUT = {
  it: [
    {
      q: 'Chi è Gabriele Denaro?',
      a: 'Gabriele Denaro è un Programmatore Senior PLC e analista, specializzato in problem solving industriale e value investing, ispirato alla filosofia di Warren Buffett e Philip Fisher. È autore del libro «Liberi di Scegliere».',
    },
    {
      q: 'Le analisi sono consulenza finanziaria?',
      a: 'No. Le informazioni su questo sito sono strumenti educativi per investitori autonomi e non costituiscono consulenza o consigli di investimento personalizzati.',
    },
  ],
  en: [
    {
      q: 'Who is Gabriele Denaro?',
      a: 'Gabriele Denaro is a Senior PLC Programmer and analyst, specialized in industrial problem solving and value investing, inspired by the philosophy of Warren Buffett and Philip Fisher. He is the author of the book "Liberi di Scegliere".',
    },
    {
      q: 'Is this analysis financial advice?',
      a: 'No. The information on this site is an educational tool for independent investors and does not constitute personalized financial or investment advice.',
    },
  ],
};

export const FAQ_ANALISI = {
  it: [
    {
      q: 'Come funziona l’analisi fondamentale dei titoli?',
      a: 'L’analisi valuta la qualità intrinseca di un’azienda in 4 fasi: qualità del business (moat e margini), qualità del management (capital allocation), valutazione finanziaria (DCF e margine di sicurezza) e decisione finale con raccomandazione BUY / HOLD / WAIT.',
    },
    {
      q: 'Il servizio è gratuito?',
      a: 'La dashboard del ciclo economico è completamente gratuita. Ogni giorno un titolo diverso, scelto a rotazione dal sistema, viene analizzato e pubblicato gratuitamente per tutti. Per analizzare un titolo a tua scelta serve un piccolo contributo tramite Stripe o Buy Me a Coffee, oppure un coupon.',
    },
  ],
  en: [
    {
      q: 'How does the fundamental stock analysis work?',
      a: 'The analysis evaluates a company’s intrinsic quality in 4 phases: business quality (moat and margins), management quality (capital allocation), financial valuation (DCF and margin of safety), and a final BUY / HOLD / WAIT recommendation.',
    },
    {
      q: 'Is the service free?',
      a: 'The economic cycle dashboard is completely free. Every day one rotating stock is analysed and published free for everyone. To analyse a ticker of your own choosing you need a small contribution via Stripe or Buy Me a Coffee, or a coupon code.',
    },
  ],
};
